var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-row",
              { attrs: { type: "flex", align: "middle" } },
              [
                _vm.statusView == "S"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDICINE_SAVE,
                            expression: "RMC_PROD_MEDICINE_SAVE",
                          },
                        ],
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.saveData("detailInfo")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    )
                  : _vm._e(),
                _vm.statusView == "S"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDICINE_SUBMIT,
                            expression: "RMC_PROD_MEDICINE_SUBMIT",
                          },
                        ],
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitData("detailInfo")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "handle-box",
            staticStyle: { "padding-bottom": "10px" },
          },
          [
            _vm._m(0),
            _c(
              "el-form",
              {
                ref: "detailInfo",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.detailInfo,
                  rules: _vm.rules,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "category3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.category3List.length > 1 &&
                                    _vm.statusView == "S"
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getCategory3Name },
                                model: {
                                  value: _vm.detailInfo.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.category3Code",
                                },
                              },
                              _vm._l(_vm.category3List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.object,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Sponsor" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "从供应商集团选择",
                              },
                              model: {
                                value: _vm.detailInfo.sponsorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "sponsorName", $$v)
                                },
                                expression: "detailInfo.sponsorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "Farm", prop: "rmcProduceFarmId" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getFarmGroupId },
                                model: {
                                  value: _vm.detailInfo.rmcProduceFarmId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "rmcProduceFarmId",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.rmcProduceFarmId",
                                },
                              },
                              _vm._l(_vm.farmList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.farmName,
                                    value: item.rmcProduceFarmId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Farm Group" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                maxlength: "100",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.detailInfo.farmGroup,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "farmGroup", $$v)
                                },
                                expression: "detailInfo.farmGroup",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "作物名称", prop: "cultiVarName" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  multiple: "",
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.cultiVarName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "cultiVarName",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.cultiVarName",
                                },
                              },
                              _vm._l(_vm.cultiVarList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "商品名", prop: "productName" } },
                          [
                            _c("el-autocomplete", {
                              staticClass: "inline-input",
                              staticStyle: { width: "100%" },
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                "fetch-suggestions": _vm.querySearch1,
                                placeholder: "请输入内容",
                                "trigger-on-focus": false,
                              },
                              on: { select: _vm.handleSelect1 },
                              model: {
                                value: _vm.detailInfo.productName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "productName", $$v)
                                },
                                expression: "detailInfo.productName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "有效成分",
                              prop: "effectiveComponents",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getSelectorForEffective },
                                model: {
                                  value: _vm.detailInfo.effectiveComponents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "effectiveComponents",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.effectiveComponents",
                                },
                              },
                              _vm._l(
                                _vm.effectiveComponentsList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _vm.isOther
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "有效成分其他",
                                  prop: "effectiveComponentsOther",
                                  rules: {
                                    required:
                                      _vm.detailInfo.effectiveComponents ==
                                      "其他"
                                        ? true
                                        : false,
                                    message: "请输入有效成分其他",
                                    trigger: "blur",
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.statusView == "S" ? false : true,
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value:
                                      _vm.detailInfo.effectiveComponentsOther,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailInfo,
                                        "effectiveComponentsOther",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailInfo.effectiveComponentsOther",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "用途分类", prop: "useClass" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  disabled: !_vm.isOther,
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.useClass,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "useClass", $$v)
                                  },
                                  expression: "detailInfo.useClass",
                                },
                              },
                              _vm._l(_vm.useClassList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.isOther ? 6 : 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "含量", prop: "contents" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.contents,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "contents", $$v)
                                },
                                expression: "detailInfo.contents",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "生产厂家", prop: "producer" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.producer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "producer", $$v)
                                },
                                expression: "detailInfo.producer",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "剂型", prop: "dosageForm" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.dosageForm,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "dosageForm", $$v)
                                  },
                                  expression: "detailInfo.dosageForm",
                                },
                              },
                              _vm._l(
                                _vm.dosageFormList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "使用方法", prop: "usage" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.usage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "usage", $$v)
                                  },
                                  expression: "detailInfo.usage",
                                },
                              },
                              _vm._l(_vm.usageList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "指导用量", prop: "guideUsage" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.guideUsage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "guideUsage", $$v)
                                },
                                expression: "detailInfo.guideUsage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "安全间隔期/天",
                              prop: "safetyDay",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入天数",
                              },
                              model: {
                                value: _vm.detailInfo.safetyDay,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "safetyDay", $$v)
                                },
                                expression: "detailInfo.safetyDay",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "最多使用次数/季",
                              prop: "maximum",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.maximum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "maximum", $$v)
                                },
                                expression: "detailInfo.maximum",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "农药登记证号",
                              prop: "pesticideNumber",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.pesticideNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "pesticideNumber",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.pesticideNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "GB 2763有限量",
                              prop: "finiteQuantity",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.changeGb },
                                model: {
                                  value: _vm.detailInfo.finiteQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "finiteQuantity",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.finiteQuantity",
                                },
                              },
                              _vm._l(_vm.options, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "其他标准",
                              prop: "otherStandard",
                              rules: {
                                required:
                                  _vm.detailInfo.finiteQuantity == "N"
                                    ? true
                                    : false,
                                message: "请输入其他标准",
                                trigger: "blur",
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled: _vm.statusView == "S" ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.otherStandard,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "otherStandard", $$v)
                                },
                                expression: "detailInfo.otherStandard",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "药品在用状态",
                              prop: "medicineUseStatus",
                            },
                          },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_RMC_PRODUCE_MEDICINE",
                                disabled: _vm.statusView == "S" ? false : true,
                                filterable: "",
                                field: "MEDICINE_USE_STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detailInfo.medicineUseStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "medicineUseStatus",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.medicineUseStatus",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_RMC_PRODUCE_MEDICINE",
                                disabled: "",
                                filterable: "",
                                field: "STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detailInfo.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "status", $$v)
                                },
                                expression: "detailInfo.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _vm.$route.query.id
                      ? _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "上次修改原因",
                                  prop: "momentUpdateReason",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    disabled: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.momentUpdateReason,
                                    callback: function ($$v) {
                                      _vm.momentUpdateReason = $$v
                                    },
                                    expression: "momentUpdateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "修改原因", prop: "modifyReason" },
                          },
                          [
                            _vm.detailInfo.modifyReason &&
                            _vm.detailInfo.modifyReason.length > 400
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.detailInfo.modifyReason,
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        autosize: { minRows: 2, maxRows: 4 },
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        disabled:
                                          _vm.statusView == "S" ? false : true,
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.detailInfo.modifyReason,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailInfo,
                                            "modifyReason",
                                            $$v
                                          )
                                        },
                                        expression: "detailInfo.modifyReason",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    disabled:
                                      _vm.statusView == "S" ? false : true,
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailInfo.modifyReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailInfo,
                                        "modifyReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailInfo.modifyReason",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.fileVisible,
              width: "30%",
              "before-close": _vm.closeFile,
            },
            on: {
              "update:visible": function ($event) {
                _vm.fileVisible = $event
              },
            },
          },
          [
            _vm.fileVisible
              ? _c("uploadFile", {
                  attrs: {
                    detailInfo: _vm.detailInfo,
                    tsReckindId: _vm.tsReckindId,
                  },
                  on: { close: _vm.closeFile },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("药品清单")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }